import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./locales/en.json";
import my from "./locales/my.json";

const langDetectorOptions = {
  order: ["localStorage", "cookie", "navigator"],

  lookupCookie: "locale",
  lookupLocalStorage: "locale",

  caches: ["localStorage", "cookie"],
  excludeCacheFor: ["cimode"], // languages to not persist (cookie, localStorage)

  checkWhitelist: true,
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: en,
      },
      my: {
        translation: my,
      },
    },
    nsSeparator: false,
    keySeparator: false,
    fallbackLng: "en",
    debug: true,
    whitelist: ["en", "my"],
    detection: langDetectorOptions,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
